import { AgmFitBounds, AgmMap } from "@agm/core";
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { MapsAPILoader } from "@agm/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Listing } from "@app/core/data/Listing";
import { environment } from "@env/environment";
import {
  Events,
  IonSlides,
  ModalController,
  NavController,
} from "@ionic/angular";
import { Geolocation } from "@ionic-native/geolocation/ngx";
import { Observable, fromEvent } from "rxjs";
import { map } from "rxjs/operators";
import { Advertisement } from "@app/core/data/Advertisement";
import { UsersApiService } from "@app/core/users-api/users-api.service";
import { AngularFireAnalytics } from "@angular/fire/analytics";
import { FavoritesService } from "@app/core/services/favorites.service";
import { DistanceUtilsService } from "@app/shared/services/distance-utils.service";
import { GenericAlertComponent } from "@app/shared/generic-alert/generic-alert.component";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from '@ionic/storage';
import { ContentAnalyticsService } from "@app/services/content-analytics.service";

declare function require(name: string);
@Component({
  selector: "app-listings-map",
  templateUrl: require("template/" +
    environment.template +
    "/html/listings-map.component.html"),
  styles: [
    require("template/" +
      environment.template +
      "/styles/listings-map.component.scss"),
  ],
})
export class ListingsMapComponent implements OnInit {
  @Input() listings: Listing[] = [];
  @Input() isLoading: Boolean = true;
  @Input() advertisements: Advertisement[] = [];
  @ViewChildren("img") ionImages: QueryList<ElementRef>;

  filteredArray: Listing[] = [];
  latitude: number;
  longitude: number;
  userLocation!: { latitude: number; longitude: number };
  zoom: number = 11;
  selectedItem!: Listing;
  slideImages: string[] = [];
  windowH: number;
  map!: google.maps.Map;
  markers: google.maps.Marker[] = [];
  userMarker?: google.maps.Marker;
  previousIndex: number = 0;
  currentIndex1: number = 0;
  private focusedMarker: google.maps.Marker | null = null;
  categoryMappings = environment.categoriesMapping;

  public environment = environment;

  // @ViewChild(AgmMap) agmMap!: AgmMap;
  // @ViewChild(AgmFitBounds) fitBounds!: AgmFitBounds;
  @ViewChild("slideWithNav2") slideWithNav2!: IonSlides;
  @ViewChild("mapa") mapa!: ElementRef;

  // slideOptsTwo = {
  //   initialSlide: 0,
  //   slidesPerView: 1.3,
  //   spaceBetween: 20
  // };

  slideOptsTwo = {
    initialSlide: 0,
    slidesPerView: 1.2,
    spaceBetween: 2,
    center: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    grabCursor: true, // para mostrar el cursor tipo "mano" que ayuda en iframe
    resistanceRatio: 0.85, // permite algo más de fluidez
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalCtrlr: ModalController,
    private userApi: UsersApiService,
    private analyticsService: AngularFireAnalytics,
    private geolocation: Geolocation,
    private navCtrl: NavController,
    public storage: Storage,
    public translate: TranslateService,
    protected contentAnalytics: ContentAnalyticsService,
    public events: Events,
    private mapsAPILoader: MapsAPILoader,
    private favorites: FavoritesService,
    private distanceUtils: DistanceUtilsService
  ) {
    this.latitude = environment.cms.main_coordinates.latitude;
    this.longitude = environment.cms.main_coordinates.longitude;

    this.initializeMap();
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      let rssLink = params.rssLink || params.deepLink;
      this.initializeMap();
      this.subscribeToEvents(rssLink);
    });
  }

  private subscribeToEvents(rssLink) {
    this.events.subscribe("testevent", async (data) => {
      if (data.listings && data.listings.length) {
        const filteredListings = this.filterUniqueListings(data.listings);
        let listings = null;
        if(filteredListings.length > 600){
          // Obtener coordenadas del centro desde environment
          const mainLat = environment.cms.main_coordinates.latitude;
          const mainLon = environment.cms.main_coordinates.longitude;
          const maxDistance = 300; // 500 millas
          const maxListings = 700; // Máximo 500 listings

          listings = filteredListings;

          // Si hay más de 500 listings, tomar solo los primeros 500
          if (listings.length > maxListings) {
            listings = listings.slice(0, maxListings);
          }
        }else{
          listings = filteredListings
        }
        // Sort by distance ascending using distance/Distance
        listings = listings.sort((a,b)=> this.normalizeMiles(a) - this.normalizeMiles(b));
        // Guardar en IndexedDB
        await this.saveMarkersToDB(listings);

        // Asignar a la variable para mostrar en la UI
        this.filteredArray = listings;
        this.adjustViewport();
        this.addMarkersInBatches(this.map, this.filteredArray);
        // In development, draw the origin pin used for distance calculations
        this.addOriginMarker();
        this.isLoading = false;

        if (this.filteredArray.length == 0) return;
        this.latitude = this.filteredArray[0].Latitude;
        this.longitude = this.filteredArray[0].Longitude;
      }
    });

  }

  private getDistanceFromLatLonInMiles(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 3958.8; // Radio de la Tierra en millas
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  private deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  private adjustViewport() {
    if (!this.filteredArray || this.filteredArray.length === 0) return;

    const firstListing = this.filteredArray[0];
    const secondListing = this.filteredArray.length > 50 ? this.filteredArray[50] : this.filteredArray[this.filteredArray.length - 1];

    if (!firstListing || !secondListing) return;

    const bounds = new google.maps.LatLngBounds();
    bounds.extend(new google.maps.LatLng(firstListing.Latitude, firstListing.Longitude));
    bounds.extend(new google.maps.LatLng(secondListing.Latitude, secondListing.Longitude));

    this.map.fitBounds(bounds);  // Ajusta el mapa al viewport calculado
  }


  async saveMarkersToDB(markers: any[]) {
    await this.storage.set('markers', markers);
  }

  async getMarkersFromDB() {
    return await this.storage.get('markers')
  }


  private filterUniqueListings(listings: any[]) {
    const uniqueMap = new Map<string, any>();

    listings.forEach((listing) => {
      const key = `${listing.Latitude}_${listing.Longitude}_${listing.SortKey}`;

      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, {
          ...listing,
          SubCategoryID: [listing.SubCategoryID],
          SubCategoryName: [listing.SubCategoryName],
          CategoryID: [listing.CategoryID],
          CategoryName: [listing.CategoryName]
        });
      } else {
        const existing = uniqueMap.get(key);
        if (!existing) return;

        // Agregar solo valores únicos
        if (!existing.SubCategoryID.includes(listing.SubCategoryID)) {
          existing.SubCategoryID.push(listing.SubCategoryID);
        }
        if (!existing.SubCategoryName.includes(listing.SubCategoryName)) {
          existing.SubCategoryName.push(listing.SubCategoryName);
        }
        if (!existing.CategoryID.includes(listing.CategoryID)) {
          existing.CategoryID.push(listing.CategoryID);
        }
        if (!existing.CategoryName.includes(listing.CategoryName)) {
          existing.CategoryName.push(listing.CategoryName);
        }
      }
    });
    return Array.from(uniqueMap.values());
  }

  getCategoryNames(categoryIds: number[]): string {
    if (!categoryIds || !Array.isArray(categoryIds)) return 'Unknown';

    return categoryIds
      .map(id => this.categoryMappings[id].displayName || 'Unknown')
      .join(', ');
  }



  logAnalytics(
    contentId: string,
    contentName: string,
    sourceScreen?: string){
    // Track content view
    this.contentAnalytics.trackContentView(
      'listing_map',
      contentId,
      contentName,
      sourceScreen
    );
  }

  onOpenListingClick(item: Listing) {
    this.logAnalytics(
      item.ListingID.toString(), // contentId (ID del listado)
      item.SortKey,              // contentName (Nombre del listado)
      'listing_map'             // sourceScreen (pantalla de origen)
    );
    // this.showLoginPopup(item.ListingID)
    this.router.navigate(['/tabs/listings', item.ListingID]);
  }

  async favoriteClick(listing) {
    await this.userApi
      .isLoggedIn()
      .then(async (loggedIn) => {
        if (loggedIn) {
          if (!listing.Favorite) {
            await this.favorites.favoriteListing(listing);
          } else {
            await this.favorites.unfavoriteListing(listing.ListingID);
          }
        } else {
          await this.showLoginPopup();
        }
        listing.Favorite = !listing.Favorite;
      })
      .catch((err) => {
        this.showLoginPopup();
      });
  }

  async showLoginPopup() {
    const modal = await this.modalCtrlr.create({
      cssClass: "my-custom-class",
      component: GenericAlertComponent,
      componentProps: {
        title: this.translate.instant("MODAL_LOGIN.TITLE"),
        message: this.translate.instant("MODAL_LOGIN.SUBTITLE"),
        buttons: [
          {
            title: this.translate.instant("MODAL_LOGIN.BTN_LOGIN"),
            value: "login",
          },
          {
            title: this.translate.instant("MODAL_LOGIN.BTN_CANCEL"),
            value: "cancel",
          },
        ],
      },
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data && data.value === "login") {
      return this.navCtrl.navigateRoot(["/login"], {
        queryParams: { redirectUrl: this.router.url },
      });
    } else {
      return "";
    }
  }
  ngAfterViewInit() {
    this.initializeMap();
  }

  private initializeMap() {

    if (!this.mapa) {
      console.error("❌ No se encontró el contenedor del mapa");
      return;
    }

    // 🛑 Elimina cualquier instancia previa del mapa
    if (this.map) {
      google.maps.event.clearInstanceListeners(this.map);
      this.map = null;
    }

    this.mapsAPILoader.load().then(() => {
      this.map = new google.maps.Map(this.mapa.nativeElement, {
        center: { lat: this.latitude, lng: this.longitude },
        zoom: 12,
        minZoom: 5,
        maxZoom: 20,
        disableDefaultUI: true,
        gestureHandling: "greedy",
      });

    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listings) {
      this.initializeMap(); // Reinicializa el mapa cuando cambian los datos
    }
  }



addMarkersInBatches(map: google.maps.Map, markersData: any[], batchSize: number = 20) {
  let allMarkers: google.maps.Marker[] = [];
  let currentIndex = 0;

  function processBatch() {
    const batch = markersData.slice(currentIndex, currentIndex + batchSize);
    const batchMarkers = batch.map((item, idx) => {
      const marker =  new google.maps.Marker({
        position: { lat: parseFloat(item.Latitude), lng: parseFloat(item.Longitude) },
        map: map,
        icon: {
          url: item.Icon,
            size: new google.maps.Size(
              item.IconWidth || 22,
              item.IconHeight || 30
            ),
            scaledSize: new google.maps.Size(
              item.IconWidth || 22,
              item.IconHeight || 30
            ),
          },
          zIndex: item.zIndex || 1,
          optimized: true,
          clickable: true,
        });
        this.currentIndex1 = allMarkers.length ? allMarkers.length + idx : idx;

        marker["originalIcon"] = marker.getIcon();
        marker.addListener("click", () => this.onMarkerClick(item, marker));
        return marker;
      }, this);

      allMarkers = allMarkers.concat(batchMarkers); // Agrega el batch de markers al arreglo total de markers
      currentIndex += batchSize;

      if (currentIndex < markersData.length) {
        setTimeout(processBatch.bind(this)(), 0); // Pausa entre lotes para mantener la UI receptiva
      } else {
        console.log("All markers have been added to the map.");
      }
    }

    processBatch.bind(this)(); // Inicia el proceso por lotes
    this.markers = allMarkers;

    this.onMarkerClick(this.filteredArray[0], this.markers[0]);
  }

  private onBoundsChange(bounds: google.maps.LatLngBounds) {
    this.filteredArray = this.listings.filter((item) =>
      bounds.contains(new google.maps.LatLng(item.Latitude, item.Longitude))
    );
    this.updateMarkers();
  }

  private updateMarkers() {
    this.markers.forEach((marker) => marker.setMap(null)); // Clear existing markers
    this.markers = []; // Reset marker array
    this.addMarkersInBatches(this.map, this.filteredArray);
    // Ensure the origin marker remains visible after refreshing markers
    this.addOriginMarker();
  }

  async onMarkerClick(listing: any, marker: any) {
    // Si hay un marcador previamente enfocado, restablece su tamaño
    if (this.focusedMarker) {
      await this.resetMarkerIcon(this.focusedMarker);
    }

    // Asigna el marcador actual como enfocado y cambia su tamaño
    // const listing = this.markers[marker];
    this.focusMarker(marker);
    this.focusedMarker = marker;

    // Desplázate al índice correspondiente en el carrusel
    const listingIdx = this.filteredArray.findIndex(
      (obj) => obj.ListingID == listing.ListingID
    );
    this.slideWithNav2.slideTo(listingIdx);
  }

  private focusMarker(marker: google.maps.Marker) {
    if (!marker) return;
    const currentIcon = marker.getIcon() as google.maps.Icon;

    const newIcon = {
      ...currentIcon,
      size: new google.maps.Size(40, 50),
      scaledSize: new google.maps.Size(40, 50),
      anchor: new google.maps.Point(20, 50),
      zoom: 20,
    };
    marker.setZIndex(25);
    marker.setIcon(newIcon);
    marker.setOptions({ optimized: true });
    this.map.panTo(marker.getPosition());
  }

  async resetMarkerIcon(marker: google.maps.Marker) {
    const originalIcon = marker["originalIcon"] as google.maps.Icon;
    if (originalIcon) {
      const newIcon = {
        ...originalIcon,
        size: new google.maps.Size(22, 30),
        scaledSize: new google.maps.Size(22, 30),
        anchor: new google.maps.Point(20, 50),
      };
      marker.setIcon(originalIcon);
    }
  }

  // Distance-related methods
  trackLocation() {
    this.geolocation
      .getCurrentPosition()
      .then((resp) => {
        this.userLocation = {
          latitude: resp.coords.latitude,
          longitude: resp.coords.longitude,
        };
        this.latitude = this.userLocation.latitude;
        this.longitude = this.userLocation.longitude;
        this.setDistance();
      })
      .catch((error) => console.error("Error getting location", error));
  }

  private setDistance() {
    this.mapsAPILoader.load().then(() => {
      const location = new google.maps.LatLng(
        this.userLocation.latitude,
        this.userLocation.longitude
      );
      this.filteredArray.forEach((item) => {
        const listingLocation = new google.maps.LatLng(
          item.Latitude,
          item.Longitude
        );
        const distanceInMeters =
          google.maps.geometry.spherical.computeDistanceBetween(
            location,
            listingLocation
          );
        // Guarda una distancia numérica en millas para ordenar correctamente
        item.Distance = this.metersToMiles(distanceInMeters);
      });
      // Orden ascendente priorizando item.distance (numérico/parseable),
      // y haciendo fallback a item.Distance si es lo único disponible
      this.filteredArray.sort((a, b) => {
        const da = this.normalizeMiles(a);
        const db = this.normalizeMiles(b);
        return da - db;
      });
    });
  }

  private metersToMiles(meters: number): number {
    return +(meters * 0.000621371).toFixed(2);
  }

  // Normaliza a millas desde item.distance (preferido) o item.Distance (fallback)
  private normalizeMiles(item: any): number {
    // 1) Preferir item.distance
    const d = item.distance;
    if (typeof d === 'number') {
      // Backend suele entregar metros como número
      return d / 1609.34;
    }
    if (typeof d === 'string') {
      const text = d.toLowerCase().replace(/,/g, '').trim();
      const val = parseFloat(text);
      if (isNaN(val)) return Number.POSITIVE_INFINITY;
      if (text.includes('km')) return val * 0.621371;
      // si dice 'mi' o sin unidad, asumir millas
      return val;
    }

    // 2) Fallback a item.Distance
    const D = item.Distance;
    if (typeof D === 'number') return D;
    if (typeof D === 'string') {
      const text = D.toLowerCase().replace(/,/g, '').trim();
      const val = parseFloat(text);
      if (isNaN(val)) return Number.POSITIVE_INFINITY;
      if (text.includes('km')) return val * 0.621371;
      return val;
    }
    return Number.POSITIVE_INFINITY;
  }

  //Method called when slide is changed by drag or navigation
  SlideDidChange(object, slideView) {
    this.filteredArray[this.previousIndex].IconWidth = 22;
    this.filteredArray[this.previousIndex].IconHeight = 30;
    this.filteredArray[this.previousIndex].zIndex = 1;

    this.slideWithNav2.getActiveIndex().then((index) => {
      this.latitude = this.filteredArray[index].Latitude;
      this.longitude = this.filteredArray[index].Longitude;

      this.onMarkerClick(this.filteredArray[index], this.markers[index]);
      // this.filteredArray[index].Icon = 'assets/icons/pin_map.svg'
      this.filteredArray[index].IconWidth = 45;
      this.filteredArray[index].IconHeight = 60;
      this.filteredArray[index].zIndex = 1000;
      this.previousIndex = index;
    });
  }

  private async addOriginMarker() {
    try {
      if (this.environment.production !== false) return; // solo en develop / no producción
      if (!this.map) return;

      const loc = await this.distanceUtils.getCurrentLocation();
      if (!loc || isNaN(+loc.latitude) || isNaN(+loc.longitude)) return;

      // Remove previous marker if exists
      if (this.userMarker) {
        this.userMarker.setMap(null);
        this.userMarker = undefined;
      }

      this.userMarker = new google.maps.Marker({
        position: { lat: +loc.latitude, lng: +loc.longitude },
        map: this.map,
        zIndex: 9999,
        clickable: false,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 6,
          fillColor: '#007bff',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
        } as google.maps.Symbol,
      });
    } catch (e) {
      // no-op
    }
  }
}

